import { render, staticRenderFns } from "./notionScreen.vue?vue&type=template&id=3e549382&scoped=true&"
import script from "./notionScreen.vue?vue&type=script&lang=js&"
export * from "./notionScreen.vue?vue&type=script&lang=js&"
import style0 from "./notionScreen.vue?vue&type=style&index=0&id=3e549382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e549382",
  null
  
)

export default component.exports